import { __read, __spread } from "tslib";
import { line } from 'd3-shape';
import { scaleLinear } from 'd3-scale';
import { getPaletteColor } from '@keen.io/charts-utils';
var createTrapezoid = function (lines) {
    return line()
        .x(function (d) { return d.x; })
        .y(function (d) { return d.y; })(lines);
};
export var calculateStepPoints = function (_a) {
    var scale = _a.scale, dimension = _a.dimension, margins = _a.margins, percentageValue = _a.percentageValue, nextPercentageValue = _a.nextPercentageValue, layout = _a.layout;
    var height = dimension.height, width = dimension.width;
    if (layout === 'horizontal') {
        scale.range([margins.top, height - margins.bottom]);
    }
    else {
        scale.range([margins.left, width - margins.right]);
    }
    var middlePoint = scale(50);
    var startMax = scale(percentageValue) / 2;
    var endMax = scale(nextPercentageValue) / 2;
    var points = layout === 'horizontal'
        ? [
            {
                x: width,
                y: middlePoint + endMax,
            },
            {
                x: 0,
                y: middlePoint + startMax,
            },
            {
                x: 0,
                y: middlePoint - startMax,
            },
            {
                x: width,
                y: middlePoint - endMax,
            },
        ]
        : [
            {
                y: height,
                x: middlePoint + endMax,
            },
            {
                x: middlePoint + startMax,
                y: 0,
            },
            {
                x: middlePoint - startMax,
                y: 0,
            },
            {
                y: height,
                x: middlePoint - endMax,
            },
        ];
    return createTrapezoid(points);
};
export var generateFunnel = function (_a) {
    var data = _a.data, key = _a.key, colors = _a.colors;
    var _b = __read(data, 1), firstSeries = _b[0];
    var maximum = firstSeries[key];
    var stepsCount = data.length;
    var range = new Array(stepsCount).fill(true);
    var steps = range.reduce(function (acc, _item, index) {
        var value = data[index][key];
        var percentageValue = maximum === 0 ? 0 : (value / maximum) * 100;
        var isLastStep = index === stepsCount - 1;
        if (isLastStep) {
            return __spread(acc, [
                {
                    nextPercentageValue: percentageValue,
                    percentageValue: percentageValue,
                    color: getPaletteColor(index, colors),
                    value: value,
                    index: index,
                },
            ]);
        }
        return __spread(acc, [
            {
                percentageValue: percentageValue,
                nextPercentageValue: maximum === 0 ? 0 : (data[index + 1][key] / maximum) * 100,
                value: value,
                color: getPaletteColor(index, colors),
                index: index,
            },
        ]);
    }, []);
    var scale = scaleLinear().domain([0, 100]);
    return {
        scale: scale,
        steps: steps,
    };
};
